import { render } from "./CommunicationView.vue?vue&type=template&id=0ad50db4"
import script from "./CommunicationView.vue?vue&type=script&lang=js"
export * from "./CommunicationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__